let slideshow = document.querySelector(".slideshow");
let slideImages = null;
let slideInfo = null;
let slideText = null;
let prevSlide = 0;
let activeSlide = 1;
let duration = 5000;
let screenSizeBig = false;
let animation = null;

if (slideshow) {
	let slideshowInfoContainer = slideshow.querySelector(".slideshow-info");
	slideImages = slideshow.querySelectorAll(".slide-image");
	slideInfo = slideshow.querySelectorAll(".slide");
	slideText = slideshow.querySelectorAll(".slide-text");
	if (slideText[0]) {
		slideText[0].style.maxHeight = slideText[0].scrollHeight + "px";
	}

	let nextArrow = slideshow.querySelector(".slide_arrow .next");
	let prevArrow = slideshow.querySelector(".slide_arrow .prev");

	// Intersection Observer for å starte animasjonen når slideshowet er synlig
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting && !animation) {
					slideshow.classList.add("slideshow-started");
					animation = setInterval(loopAnimation, duration);
				}
			});
		},
		{
			threshold: 0.2,
		}
	);

	observer.observe(slideshow);
	if (slideText[0]) {
		slideshowInfoContainer.style.minHeight =
			slideshowInfoContainer.scrollHeight + "px";
	} else {
		slideshowInfoContainer.style.minHeight =
			slideshowInfoContainer.scrollHeight + 50 + "px";
	}

	let screenWidth = document.body.clientWidth;

	if (screenWidth >= 900) {
		screenSizeBig = true;
	} else {
		screenSizeBig = false;
	}

	nextArrow.addEventListener("click", function (event) {
		clearInterval(animation);
		clearAll();
		slideImages[activeSlide].classList.add("active");
		slideInfo[activeSlide].classList.add("active");
		if (slideText[activeSlide]) {
			slideText[activeSlide].style.maxHeight =
				slideText[activeSlide].scrollHeight + "px";
		}

		slideImages[prevSlide].classList.remove("active");
		if (slideText[prevSlide]) {
			slideText[prevSlide].style.maxHeight = "0px";
		}
		slideInfo[prevSlide].classList.remove("active");

		if (activeSlide >= slideImages.length - 1) {
			activeSlide = 0;
			prevSlide = slideImages.length - 1;
		} else {
			prevSlide = activeSlide;
			activeSlide++;
		}
		animation = setInterval(loopAnimation, duration);
	});

	prevArrow.addEventListener("click", function (event) {
		clearInterval(animation);
		clearAll();
		if (prevSlide <= 0) {
			activeSlide = 0;
			prevSlide = slideImages.length - 1;
		} else {
			activeSlide = prevSlide;
			prevSlide--;
		}
		slideImages[prevSlide].classList.add("active");
		slideInfo[prevSlide].classList.add("active");
		if (slideText[prevSlide]) {
			slideText[prevSlide].style.maxHeight =
				slideText[prevSlide].scrollHeight + "px";
		}
	});

	if (screenSizeBig == true) {
		for (let i = 0; i < slideImages.length; i++) {
			slideInfo[i].addEventListener("mouseenter", function (event) {
				clearInterval(animation);
				clearAll();
				slideImages[i].classList.add("hover");
				if (slideText[i] && slideText[activeSlide]) {
					slideText[i].style.maxHeight =
						slideText[activeSlide].scrollHeight + "px";
				}
				slideInfo[i].classList.add("hover");
			});

			slideInfo[i].addEventListener("mouseleave", function (event) {
				// Sjekk at musen faktisk forlater slide-elementet
				const relatedTarget = event.relatedTarget;
				if (!relatedTarget || !slideInfo[i].contains(relatedTarget)) {
					slideImages[i].classList.remove("hover");
					slideInfo[i].classList.remove("hover");
					if (slideText[i]) {
						slideText[i].style.maxHeight = "0px";
					}

					// Fortsett fra det aktive slidet (der vi var før hover)
					slideImages[prevSlide].classList.add("active");
					slideInfo[prevSlide].classList.add("active");
					if (slideText[prevSlide]) {
						slideText[prevSlide].style.maxHeight =
							slideText[prevSlide].scrollHeight + "px";
					}

					animation = setInterval(loopAnimation, duration);
				}
			});
		}
	}
}

function loopAnimation() {
	slideImages[activeSlide].classList.add("active");
	slideInfo[activeSlide].classList.add("active");
	if (slideText[activeSlide]) {
		slideText[activeSlide].style.maxHeight =
			slideText[activeSlide].scrollHeight + "px";
	}

	slideImages[prevSlide].classList.remove("active");
	if (slideText[prevSlide]) {
		slideText[prevSlide].style.maxHeight = "0px";
	}
	slideInfo[prevSlide].classList.remove("active");

	if (activeSlide >= slideImages.length - 1) {
		activeSlide = 0;
		prevSlide = slideImages.length - 1;
	} else {
		prevSlide = activeSlide;
		activeSlide++;
	}
}

function clearAll() {
	for (let i = 0; i < slideImages.length; i++) {
		slideImages[i].classList.remove("active", "hover");
		if (slideText[i]) {
			slideText[i].style.maxHeight = "0px";
		}
		slideInfo[i].classList.remove("active", "hover");
	}
}
